import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/office/');


export async function loadOffices(ids) {
    const { result } = await doRequest('loadList', { ids });
    return result;
}

export async function saveOffice(reqt) {
    const { result } = await doRequest('save', reqt, { blocking: true });
    return result;
}

export async function searchOffice(query = '', cluster = null) {
    const { result } = await doRequest('find', {
        query,
        limit: 12,
        cluster,
    }, {
        messages: false,
    });
    return result;
}

export async function resolveOffice(id) {
    const { result } = await doRequest('get', { id });
    return result;
}

export async function loadOffice(id) {
    const { result } = await doRequest('load', { id });
    return result;
}

export async function updateDocuments(reqt) {
    await doRequest('update/documents', reqt, { blocking: true });
}

export async function updateLinks(reqt) {
    await doRequest('update/links', reqt, { blocking: true });
}

export async function updateContacts(reqt) {
    await doRequest('update/contacts', reqt, { blocking: true });
}

export async function saveAccess(reqt) {
    const { result } = await doRequest('update/access', reqt, { blocking: true });
    return result;
}

export async function deleteOffice(id) {
    const { result } = await doRequest('delete', { id });
    return result;
}
